<div class="container-fluid">
  <form #fiscalPayForm="ngForm">
    <!-- Header -->

    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-3 vcenter">
        <h4 class="page-header">{{headerText}}</h4>
      </div>
      <div class="col-xs-12 col-lg-9 vcenter-right">

        <div class="btn-group" role="group" aria-label="...">
          <button type="button"
                  *ngIf="fiscalPayForm.dirty"
                  class="btn btn-default btn-sm"
                  (click)="cancel()">
            <i class="fas fa-ban"></i>&nbsp;Cancel
          </button>

          <button type="button"
                  class="btn btn-success btn-sm"
                  *ngIf="(canCreate)"
                  [disabled]="(!fiscalPayForm.valid)"
                  (click)="autoGeneratePscs()">
            <i class="fas fa-plus"></i>&nbsp;Create PSCs
          </button>

          <button type="button"
                  class="btn btn-primary btn-sm"
                  *ngIf="(canPmmApprove)"
                  (click)="updatePmmApproval()">
            <i class="fas fa-thumbs-up"></i>&nbsp;PMM Approved
          </button>

          <button type="button"
                  class="btn btn-primary btn-sm"
                  *ngIf="(canHrmApprove)"
                  [disabled]="(!fiscalPayForm.valid)"
                  (click)="updateHrmApproval()">
            <i class="fas fa-thumbs-up"></i>&nbsp;HRM Approved
          </button>

          <button type="button"
                  class="btn btn-secondary btn-sm"
                  *ngIf="(canPrint)"
                  (click)="printAll()">
            <i class="fas fa-archive"></i>&nbsp;Print All
          </button>

        </div>

      </div>

    </div>
    <div class="row">
      <div class="col-xs-1 text-right">
        <label for="dropdownlist">Select Fiscal Year:</label>
      </div>
      <div class="col-xs-2">
        <mat-form-field appearance="fill">
          <mat-select
            name="fyYears"
            [(ngModel)]="fyYear"
            (selectionChange)="getFromToPayRates()"
            required >
            <mat-option *ngFor="let fy of fyYearValues | async" [value]="fy"> {{ fy }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">

      <div id="grid">
        <div class="row">
          <div class="col-xs-12">
            <aims-common-table
              id="psc-gen-fiscal-pay-table"
              [dataSource]="fiscalPay | async"
              [header]="tableHeader"
              [permissions]="tablePermissions"
              [pageSize]="10"
              [stickyHeader]="true">

              <aims-common-table-dynamic-row id="payRateFrom">
                <ng-template viewMode let-element >
                  <span class="whole-cell" [ngStyle]="pscFunc.colorCodeNumber(element.payRateFrom)">
                    {{ element.payRateFrom | currency}}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="payRateTo">
                <ng-template viewMode let-element >
                  <span class="whole-cell" [ngStyle]="pscFunc.colorCodeNumber(element.payRateTo)">
                    {{element.payRateTo | currency}}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="percentage">
                <ng-template viewMode let-element >
                  <span class="whole-cell" [ngStyle]="pscFunc.colorCodeNumber(element.percentage)">
                    {{element.percentage | percent:'1.2-5'}}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="pmmApprovedById">
                <ng-template viewMode let-element >
                  {{ element.pmmApprovedById | getText:'employeeId':'fullName':employeeValues }}
                </ng-template>

                <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                  <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                    <mat-label>Filter</mat-label>
                    <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                      <mat-option label=""></mat-option>
                      <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId">
                        {{ e.fullName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </aims-common-table-dynamic-row>

               <aims-common-table-dynamic-row id="hrmApprovedById">
                <ng-template viewMode let-element >
                  {{ element.hrmApprovedById | getText:'employeeId':'fullName':employeeValues }}
                </ng-template>

                <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                  <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                    <mat-label>Filter</mat-label>
                    <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                      <mat-option label=""></mat-option>
                      <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId">
                        {{ e.fullName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </aims-common-table-dynamic-row>

            </aims-common-table>
          </div>
        </div>
      </div>

    </div>
  </form>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

  <!--//Hardcoded to 10/1/fyYear -- Acct said it is always 10/1-->

  <!--<div *ngIf="showEffectiveOnPopUp" class="modal fade in" id="effectiveOn" tabindex="-1" role="dialog" aria-labelledby="effectiveOn" data-backdrop="static" style="display:block">
    <div class="modal-dialog centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Enter Effective On date for Union Fiscal Pay Changes
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">

              <div class="row top10 no-gutters">
                <div class="col-xs-5 text-right">
                  <b>Effective On:&nbsp;&nbsp;</b>
                </div>
                <div class="col-xs-7">
                  <datepicker name="Completed On"
                                    [(ngModel)]="effectiveOn"
                                    required>
                  </datepicker>
                </div>
              </div>

            </div>
          </div>
          <div class="row top10">
            <div class="modal-footer">
              <button type="button" class="btn btn-default" (click)="cancelEffectiveOn()">Cancel</button>
              <button type="button" class="btn btn-primary" [disabled]="effectiveOn == null" (click)="autoGeneratePscs()">Create Fiscal PSCs</button>
            </div>
          </div>
        </div>
    </div>
  </div>-->

</div>

